module.exports = __webpack_public_path__ + "static/media/The Etho Word Logo.88b21a32.png";